import * as React from 'react';
import {css, injectGlobal} from "emotion";
import * as moment from "moment";

export const initTheme = () => {
    require('react-dates/initialize');
    require('react-dates/lib/css/_datepicker.css');
    require('react-toggle/style.css');
    require('static/icons/style.css');

    const fix = require('@src/styles/fix'); 
    const commmon = require('@src/styles/common'); 

    injectGlobal(`
        ${fix.amCharts}
        ${fix.reactTable}
        ${fix.datePicker}
        ${commmon.login}
    `);
}

export const vars = {
    colors: {
        white: "#ffffff",
        black: "#000000",
        yellow: "#e9b300",
        red: "#ff0000",
        orange: "#ffcc00",
        green: "#b7e021",
        blue: "#00008b",
        greyLight: "#f1f3f4",
        greyDark: "#333333",
        grey: "#cccccc"
    },
    gutter: 30,
    shadow: "0px 0px 10px 0px rgba(0,0,0,0.4)",
};

const lvars = {
    icon: 160,
    counter: 60
}
export const mixin = {
    row: `
        display: flex;
        margin: ${-vars.gutter/2}px;
        > * {
            flex: 1;
            margin: ${vars.gutter/2}px;
        }
    `,
    row2: `
        display: flex;
        margin: ${-vars.gutter/2}px;
        > * {
            margin: ${vars.gutter/2}px;
            &:first-child {
                width: 300px;
            }
            &:last-child {
                flex: 1;
            }
        }  
    `,
    center: `
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    `,
    iconBadge: `
        position: relative;
        display: inline-block;
        > strong {
            position: absolute;
            margin-left: -${lvars.counter}px;
            margin-top: -${lvars.counter/2}px;
            min-width: ${lvars.counter}px;
            line-height: ${lvars.counter}px;
            white-space: nowrap;
            text-align: center;
            font-size: 20px;
            background: #cccccc;
            border-radius: ${lvars.counter}px;

            > span {
                display: block;
                padding: 0 10px;
            }
        }
        > i {
            display: inline-block;
            text-align: center;
            font-size: 100px;
            width: ${lvars.icon}px;
            line-height: ${lvars.icon}px;
            background-color: #eee;
            border: 3px solid #cccccc;
            border-radius: 100%;
            box-shadow: 0px 0px 69px -13px rgba(0,0,0,0.75);
        }
        &.STATUS_OK > i {
            color: ${vars.colors.white};
            background-color: ${vars.colors.green};
        }
        &.STATUS_WARNING > i {
            color: ${vars.colors.white};
            background-color: ${vars.colors.orange};
        }
        &.STATUS_KO > i {
            color: ${vars.colors.white};
            background-color: ${vars.colors.red};
        }
        &.STATUS_UNKNOWN > i {
            color: ${vars.colors.white};
            background-color: ${vars.colors.grey};
        }
    `,
    status: `
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 100%;
    `,
    subTitle: `
        font-size: 14px;
        color: ${vars.colors.grey};
        text-transform: uppercase;
    `,
    form: `
        .fields {
            display: flex;
            margin: 0 -${vars.gutter/2}px;
            flex-wrap: wrap;
            > * {
                width: 50%;
                padding: 10px ${vars.gutter/2}px;
                &.pt {
                    width: 25%;
                }
                &.full {
                    width: 100%;
                }
            }
            > article {
                > label {
                    display: block;
                    text-transform: uppercase;
                    font-size: 12px;
                }
                > input, > select, > textarea {
        
                }
                &.switch {
                    padding-top: 38px;
                    > label {
                        display: inline-block;
                        padding-right: 1em;
                        margin: 0;
                    }
                    > * {
                        vertical-align: middle;
                    }
                }
            }
        }
        > footer {
            display: flex;
            justify-content: space-between;
            > button {
                &:last-child {
                    min-width: 200px;
                }
            }
        }
    `,
    legend: `
        text-align: center;
        font-size: 16px;
        padding: 30px;

        > span {
            position: relative;
            margin: 0 35px;
            &:before {
                content: "";
                width: 18px;
                height: 18px;
                position: absolute;
                top: 0px;
                left: -25px;
            }
            &.lgnd-orange:before {
                background-color: ${vars.colors.orange};
            }
            &.lgnd-green:before {
                background-color: ${vars.colors.green};
            }
            &.lgnd-red:before {
                background-color: ${vars.colors.red};
            }
            &.lgnd-blue:before {
                background-color: ${vars.colors.blue};
            }
            &.lgnd-yellow:before {
                background-color: ${vars.colors.yellow};
            }
            &.lgnd-grey:before {
                background-color: ${vars.colors.grey};
            }
        }
    `,
    lastState: `
        > * {
            display: flex;
            width: 50%;
            padding: 10px;
            border: 1px solid #ccc;

            > figure {
                align-self: center;
                width: 120px;
                font-size: 70px;
                text-align: center;
                padding: 0 20px;
            }
            > div {
                h4 {
                    font-size: 18px;
                    line-height: 18px;
                    font-weight: bold;
                    padding-bottom: 20px;
                    text-transform: uppercase;
                }
                table {
                    background: none;
                    td {
                    }
                }
            }
        }
        > .state->info {
            background-color: #0000ff;
        }
        > .state-warning {
            background-color: #ffcc00;
        }
        > .state-error {
            background-color: #ff0000;
        }
        > .state-fault {
            background-color: #000000;
        }
        > .actions {
            background-color: #ffcc99;
        }
    `,
    statusColor: `
        &.STATUS_OK {
            color: ${vars.colors.white};
            background-color: ${vars.colors.green};
        }
        &.STATUS_WARNING {
            color: ${vars.colors.white};
            background-color: ${vars.colors.orange};
        }
        &.STATUS_KO {
            color: ${vars.colors.white};
            background-color: ${vars.colors.red};
        }
        &.STATUS_UNKNOWN {
            color: ${vars.colors.white};
            background-color: ${vars.colors.grey};
        }
    `
}

const styleStatus = (status) => {
    let c = vars.colors.red;
    if (status === 1) c = vars.colors.orange;
    if (status === 2) c = vars.colors.green;
    return { backgroundColor: c };
}
export const formatters = {
    date: (val) => {
        return moment(val).format("DD/MM/YYYY");
    }, 
    datetime: (val) => {
        return moment(val).format("DD/MM/YYYY HH:mm:ss");
    },
    status: (val) => {
        return <span className={css(mixin.status)} style={styleStatus(val)} />;
    },
    yesNo: (val, trueLbl = 'yes', falseLbl = 'no') => {
        return val ? trueLbl : falseLbl;
    },
    percent: (val, total) => {
        return (val / total * 100).toFixed(2);
    },
    number: (val, args = {}) => {
        const _args = {
            precision: 2,
            ...args,
        }
        return (val).toFixed(_args.precision);
    },
}

export const defaultProps = {
    table: (args = {} as any) => {
        let res = {
            minRows: 5,
            showPagination: false,
            showPageSizeOptions: false,
            showPageJump: false
        } as any;
        if (args.showPagination) {
            res = {
                ...res,
                showPagination: true,
            }
        }
        if (args.onClick) {
            res = {
                ...res,
                getTrProps: (state, rowInfo) => {
                    return {
                        className: "clickable",
                        onClick: e => {
                            args.onClick(rowInfo.original);
                        },
                    };
                },
            }
        }
        return res;
    },
    graphGauge: {
        "theme": "light",
        "type": "gauge",
        "axes": [{
            "topTextFontSize": 20,
            "topTextYOffset": 70,
            "axisColor": "#31d6ea",
            "axisThickness": 1,
            "endValue": 100,
            "gridInside": true,
            "inside": true,
            "radius": "50%",
            "valueInterval": 10,
            "tickColor": "#67b7dc",
            "startAngle": -135,
            "endAngle": 135,
            "unit": "%",
            "bandOutlineAlpha": 0,
            "bands": [{
                "color": "#0080ff",
                "endValue": 100,
                "innerRadius": "105%",
                "radius": "170%",
                "gradientRatio": [0.5, 0, -0.5],
                "startValue": 0
            }, {
                "color": "#3cd3a3",
                "endValue": 0,
                "innerRadius": "105%",
                "radius": "170%",
                "gradientRatio": [0.5, 0, -0.5],
                "startValue": 0
            }]
        }],
        "arrows": [{
            "alpha": 1,
            "innerRadius": "35%",
            "nailRadius": 0,
            "radius": "170%"
        }],
        "responsive": {
            "enabled": true
        }
    },
    graphArea: (args = {} as any) => ({
        "type": "serial",
        "theme": "light",
        "marginLeft": 10,
        "marginRight": 10,
        "balloon": {
            "cornerRadius": 6,
            "horizontalPadding": 15,
            "verticalPadding": 10
        },
        "graphs": [{
            "bullet": "square",
            "bulletBorderAlpha": 1,
            "bulletBorderThickness": 1,
            "hideBulletsCount": 50,
            "fillAlphas": 0.3,
            "fillColors": vars.colors.grey,
            "lineColor": vars.colors.grey,
            "fillColorsField": "lineColor",
            "legendValueText": "[[value]]",
            "lineColorField": "lineColor",
            "title": args.title || "",
            "valueField": args.field || "val"
        }],
        "chartScrollbar": {
        },
        "chartCursor": {
            "categoryBalloonDateFormat": "HH:NN",
            "cursorAlpha": 0,
            "fullWidth": true
        },
        /*"dataDateFormat": "YYYY-MM-DD HH:NN:SS",*/
        "categoryField": "date",
        "categoryAxis": {
            "minPeriod": "mm",
            "parseDates": true,
            "autoGridCount": false,
            "axisColor": "#555555",
            "gridAlpha": 0,
            "gridCount": 15
        },
        "valueAxes": [
            {
                "title": args.titleY || '',
                "minimum": 0,
                "maximum": 100,
                "autoGridCount": false,
                "gridCount": 10,
            }
        ],
        "export": {
            //"enabled": true
        },
    }),
    graphAreaCharge: (args = {} as any) => ({
        "type": "serial",
        "theme": "light",
        "marginLeft": 10,
        "marginRight": 10,
        "balloon": {
            "cornerRadius": 6,
            "horizontalPadding": 15,
            "verticalPadding": 10
        },
        "graphs": [{
            "balloonText": "<div style='margin:5px;'><b>SOC: [[x]]</b><br>Cycle: <b>[[y]]</b></div>",
            "bullet": "square",
            "bulletBorderAlpha": 1,
            "bulletBorderThickness": 1,
            "hideBulletsCount": 50,
            "fillAlphas": 0.3,
            "fillColors": vars.colors.grey,
            "lineColor": vars.colors.grey,
            "fillColorsField": "lineColor",
            "xField": "val",
            "yField": "cycle",
            "lineColorField": "lineColor",
            "valueField": args.field || "val"
        }],
        "chartScrollbar": {
        },
        "chartCursor": {
            "categoryBalloonDateFormat": "HH:NN",
            "cursorAlpha": 0,
            "fullWidth": true
        },
        /*"dataDateFormat": "YYYY-MM-DD HH:NN:SS",*/
        "categoryField": "date",
        "categoryAxis": {
            "minPeriod": "mm",
            "parseDates": true,
            "autoGridCount": false,
            "axisColor": "#555555",
            "gridAlpha": 0,
            "gridCount": 15
        },
        "valueAxes": [
            {
                "title": args.titleY || '',
                "minimum": 0,
                "maximum": 100,
                "autoGridCount": false,
                "gridCount": 10,
            }
        ],
        "export": {
            //"enabled": true
        },
    }),
    graphLine: (args = {} as any) => ({
        "type": "serial",
        "theme": "light",
        "marginRight": 70,
        "autoMarginOffset": 20,
        "balloon": {
            "cornerRadius": 6
        },
        "valueAxes": [{
            "axisAlpha": 0
        }],
        "graphs": [{
            "balloonText": args.text || "",
            "bullet": "round",
            "bulletSize": 6,
            "connect": true,
            "lineColor": "#ff0000",
            "lineThickness": 2,
            "negativeLineColor": "#3333cc",
            "valueField": args.field || "val",
        }],
        "chartCursor": {
            "categoryBalloonDateFormat": "YYYY-MM-DD",
            "cursorAlpha": 0.1,
            "cursorColor": "#000000",
            "fullWidth": true,
            "graphBulletSize": 2
        },
        "chartScrollbar": {},
        "dataDateFormat": "YYYY-MM-DD",
        "categoryField": "date",
        /*"categoryAxis": {
            "minPeriod": "DD",
            "parseDates": true,
            "minorGridEnabled": false
        }*/
    }),
    columns: {
        id: {
            Header: 'ID', width: 60, accessor: 'id', className: "id"
        },
        switch: {
            Header: 'Status', width: 60, accessor: 'active'
        }
    }
} as any;

// classNames minimal module
export const classNames = (...args) => {
	return args.join(' ');
}

// re-export
export { css };


// WEBPACK FOOTER //
// ./src/services/theme.tsx